import { connect } from 'react-redux';
import InstructorsRatingsSummary from './InstructorsRatingsSummary';
import { updateInstructor } from '../Ratings.saga';
import { selectInstructorsRatings, selectInstructorsRatingsIsLoading } from '../Ratings.selectors';

const mapStateToProps = state => ({
  instructorsRatings: selectInstructorsRatings(state),
  isLoading: selectInstructorsRatingsIsLoading(state),
});

const mapDispatchToProps = { updateInstructor };

export default connect(mapStateToProps, mapDispatchToProps)(InstructorsRatingsSummary);
